import { useContext, useMemo } from 'react';
import SelectedEntityContext from '../contexts/SelectedEntityContext';
import { DefaultDatasetFiltersContext } from '../../../contextProviders/SplashScreenProviders/DatasetProviders/DefaultDatasetFiltersProvider';
import mergeFilterInputs from '../../../mergeFilterInputs';

const usePerformanceSlideOutFilterInput = ({
  datasetForDefaultFiltering,
}: {
  datasetForDefaultFiltering?: string;
}) => {
  const { defaultDatasetFiltersLookup } = useContext(
    DefaultDatasetFiltersContext,
  );
  const { entityField, selectedEntity } = useContext(SelectedEntityContext);

  const entityFilter = useMemo(() => {
    if (!selectedEntity) {
      return;
    }

    const selectedEntityFilterInput = {
      keywords: [{ field: entityField, values: [selectedEntity] }],
    };

    return selectedEntityFilterInput;
  }, [entityField, selectedEntity]);

  const datasetFilter = useMemo(() => {
    if (!datasetForDefaultFiltering) {
      return undefined;
    }

    return defaultDatasetFiltersLookup[datasetForDefaultFiltering];
  }, [datasetForDefaultFiltering, defaultDatasetFiltersLookup]);

  const filterInput = useMemo(() => {
    if (!entityFilter) {
      return undefined;
    }

    if (datasetFilter && entityFilter) {
      return mergeFilterInputs(entityFilter, datasetFilter.filterInput);
    }

    return entityFilter;
  }, [datasetFilter, entityFilter]);

  return filterInput;
};

export default usePerformanceSlideOutFilterInput;
